module.exports = __webpack_public_path__ + "static/media/use-case-2.f66e90a4.jpg";